// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../shared/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cui-chr-tab {\n  .tab-content {\n    padding: 0;\n    .tab-pane {\n      padding: 0;\n    }\n  }\n\n  ul.nav.nav-tabs {\n    padding-left: 15px;\n\n    li a {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n}\n", ""]);
// Exports
module.exports = exports;
